import SelectLocation from 'core-lib/components/SelectLocation';
import { customToast } from 'core-lib/utils/customToast';
import { isStringValid } from 'core-lib/utils/utils';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AnimatedImage, Input, Typography } from 'ui';
import { ModalTypeTypes } from 'ui/components/Modal/Modal';
import Star from 'ui/components/newIcons/Star';
import Star1 from 'ui/components/newIcons/Star1';
import DealersList from '../../components/popups/DealersList';
import { updateDealer } from '../../store';
import { ListType } from '../../types';
import s from './Form.module.scss';

interface FormProps {
  data: ListType;
  handleChange: (name, value) => void;
  form: any;
  showDealerInput: boolean;
  showEmailInput: boolean;
  handleCityChange: (location) => void;
  address: any;
  locationPopupVariant?: ModalTypeTypes;
  isWeb?: boolean;
}

const Form = ({
  data,
  handleChange,
  form,
  showDealerInput,
  showEmailInput,
  handleCityChange,
  address,
  locationPopupVariant = 'page',
  isWeb = false
}: FormProps) => {
  const [showCityPopup, setShowCityPopup] = useState(false);
  const [showDealerList, setShowDealerList] = useState(false);

  const dispatch = useDispatch();

  return (
    <div className={s.root}>
      {data && (
        <div className={s.header}>
          <div className={s.title}>
            <div>
              <Typography label={`${data?.displayModelName}`} variant='h2' />
              <p>
                <Typography
                  label={`${data?.displayPrice}`}
                  variant='h3'
                  style={{ paddingTop: '8px' }}
                  renderAs='SPAN'
                />
                <Typography
                  label=' onwards'
                  variant='body_para_m'
                  color='text_subheading'
                  renderAs='SPAN'
                />
              </p>
            </div>
            <div className={s.logoWrapper}>
              <AnimatedImage
                src={data?.metaData?.brandLogo}
                className={s.brandLogo}
              />
            </div>
          </div>
          <div className={s.rating}>
            {Array(5)
              .fill(1)
              .map((item, idx) => (
                <>
                  {idx + 1 <= Math.floor(data?.rating) ? (
                    <Star1
                      key={`${idx})*&`}
                      width={16}
                      height={16}
                      primaryColor='warning_60'
                    />
                  ) : (
                    <Star
                      key={`${idx})*&`}
                      width={16}
                      height={16}
                      primaryColor='text_label'
                    />
                  )}
                </>
              ))}
            <Typography
              label={`${data?.ratingCount} ratings`}
              variant='body_para_r'
              color='text_subheading'
              style={{ paddingLeft: '8px' }}
            />
          </div>
        </div>
      )}
      <div className={s.form}>
        <div className={s.input}>
          <p style={{ paddingBottom: '4px' }}>
            <Typography
              label='Enter your name'
              variant='body_para_m'
              color='text_label'
              renderAs='SPAN'
            />
            <Typography
              label=' *'
              variant='body_para_m'
              color='negative_70'
              renderAs='SPAN'
            />
          </p>
          <Input
            name='name'
            onChange={(e: any) => {
              handleChange('name', e.target.value);
            }}
            value={form.name.input}
            placeholder='Enter your name'
            hasError={isStringValid(form.name.err)}
            errorMessage={form.name.err}
          />
        </div>
        <div
          onClick={() => {
            setShowCityPopup(true);
          }}
          className={s.input}
        >
          <p style={{ paddingBottom: '4px' }}>
            <Typography
              label='Your city'
              variant='body_para_m'
              color='text_label'
              renderAs='SPAN'
            />
            <Typography
              label=' *'
              variant='body_para_m'
              color='negative_70'
              renderAs='SPAN'
            />
          </p>
          <Input
            name='city'
            onChange={(e: any) => {
              handleChange('city', e.target.value);
              handleChange('dealer_name', '');
              dispatch(updateDealer(null));
            }}
            value={form.city.input}
            placeholder='Enter your city'
            hasError={isStringValid(form.city.err)}
            errorMessage={form.city.err}
            readOnly
          />
        </div>
        {showDealerInput && form.city.input && (
          <div
            className={s.input}
            onClick={() => {
              setShowDealerList(true);
            }}
          >
            <p style={{ paddingBottom: '4px' }}>
              <Typography
                label='Select dealer'
                variant='body_para_m'
                color='text_label'
                renderAs='SPAN'
              />
              <Typography
                label=' *'
                variant='body_para_m'
                color='negative_70'
                renderAs='SPAN'
              />
            </p>
            <Input
              name='dealer_name'
              onChange={(e: any) => {
                handleChange('dealer_name', e.target.value);
              }}
              value={form.dealer_name.input}
              placeholder='Choose your preferred dealer'
              hasError={isStringValid(form.dealer_name.err)}
              errorMessage={form.dealer_name.err}
              readOnly
            />
          </div>
        )}
        {showEmailInput && (
          <div className={s.input}>
            <p style={{ paddingBottom: '4px' }}>
              <Typography
                label='Enter email ID'
                variant='body_para_m'
                color='text_label'
                renderAs='SPAN'
              />
            </p>
            <Input
              name='email'
              onChange={(e: any) => {
                handleChange('email', e.target.value);
              }}
              value={form.email.input}
              placeholder='Enter your email'
              hasError={isStringValid(form.email.err)}
              errorMessage={form.email.err}
            />
          </div>
        )}
        <div className={s.input}>
          <p style={{ paddingBottom: '4px' }}>
            <Typography
              label='Enter phone number'
              variant='body_para_m'
              color='text_label'
              renderAs='SPAN'
            />
            <Typography
              label=' *'
              variant='body_para_m'
              color='negative_70'
              renderAs='SPAN'
            />
          </p>
          <Input
            name='phone'
            onChange={(e: any) => {
              handleChange('phone', e.target.value);
            }}
            value={form.phone.input}
            placeholder='Enter your phone number'
            hasError={isStringValid(form.phone.err)}
            errorMessage={form.phone.err}
            disabled
          />
        </div>
      </div>
      <SelectLocation
        show={showCityPopup}
        onClose={() => {
          setShowCityPopup(false);
        }}
        containerStyle={
          locationPopupVariant === 'fullScreenPopup'
            ? {
                height: '600px',
                paddingTop: '40px',
              }
            : {}
        }
        onDone={(location) => {
          handleCityChange(location);
        }}
        autoFocus={false}
        addressValidation={['latitude', 'longitude']}
        customRootStyle={{ zIndex: 4 }}
        variant={locationPopupVariant}
        isWeb={isWeb}
      />
      <DealersList
        onSelect={(dealer) => {
          handleChange('dealer_name', dealer?.dealerTradeName);
          dispatch(updateDealer(dealer));
        }}
        onClose={() => {
          setShowDealerList(false);
        }}
        show={showDealerList}
        lat={address?.data?.latitude}
        long={address?.data?.longitude}
        showToast={() => {
          customToast({
            label: 'Currently we are not serviceable at your location',
            variant: 'criticalNotPriority',
          });
        }}
      />
    </div>
  );
};

export default Form;
